<template>
  <div class="section-box__footer">

    <ul>
      <!-- <li><a href="#"><img src="./../../assets/icon-play.svg" alt="play icon">Play real</a></li> -->
      <li @click="goToSection(10)">About us</li>
      <li @click="goToSection(12)">Send brief</li>
    </ul>

  </div>
</template>

<script>

export default {
  name: 'MainSectionFooter',
  data () {
    return {

    }
  },
  methods: {
    goToSection: function(sectionNumber) {

      this.$parent.$emit("ChangeActiveSection", sectionNumber);

    },
  },
  props: ['title', 'subtitle']

}
</script>



// WEBPACK FOOTER //
// src/components/small-components/MainSectionFooter.vue